// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import axios from 'axios';
import { get, trim } from 'lodash';

import * as Constants from '../../constants';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';
import { AXIOS_DEFAULT_OPTIONS } from '../';

export const fetchAPISettingsSpecDefaultProxy = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/settings/API_DESCRIPTOR_HOST_OVERRIDE`;

    dispatch({
      type: Constants.API_SETTINGS_SPEC_DEFAULT_PROXY_GET_REQUEST,
    });

    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: Constants.API_SETTINGS_SPEC_DEFAULT_PROXY_GET_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: Constants.API_SETTINGS_SPEC_DEFAULT_PROXY_GET_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

  export const fetchAPISettingsEnforceCategoryOrdering = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/settings/ENFORCE_CATEGORY_ORDERING`;

    dispatch({
      type: Constants.API_SETTINGS_GET_REQUEST,
    });

    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: Constants.API_SETTINGS_GET_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: Constants.API_SETTINGS_GET_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

  export const updateAPISettings = (
    value,
  ) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/settings/ENFORCE_CATEGORY_ORDERING`;

    dispatch({
      type: Constants.API_SETTINGS_UPDATE_REQUEST,
    });

    await axios.put(url, { "value": `${value}`, "name": 'ENFORCE_CATEGORY_ORDERING' }, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: Constants.API_SETTINGS_UPDATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        const validationErrors = get(error, 'response.data.error');
        dispatch({
          type: Constants.API_SETTINGS_UPDATE_ERROR,
          payload: {
            errors: validationErrors,
          },
        });
      });
  };

  export const updateAPISettingSpecDefaultProxy = (
    value,
  ) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/settings/API_DESCRIPTOR_HOST_OVERRIDE`;


    dispatch({
      type: Constants.API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_REQUEST,
    });

    // API expects to send null value if we have to clear the field.
    const newValue = trim(value) === '' ? null : trim(value);

    await axios.put(url, { "value": newValue, "name": 'API_DESCRIPTOR_HOST_OVERRIDE' }, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: Constants.API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        const validationErrors = get(error, 'response.data.error');
        dispatch({
          type: Constants.API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_ERROR,
          payload: {
            errors: validationErrors,
          },
        });
      });
  };
